<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Keyword Rankings
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/keywords"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>
    <div
      v-if="!loading && keywords.length > 0"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td style="width: 35%">
              <span>Keyword</span>
            </td>
            <td style="width: 20%">
              <span>Position</span>
            </td>
            <td style="width: 20%">
              <span>Search Volume</span>
            </td>
            <td style="width: 25%">
              <span>Difficulty</span>
            </td>
          </tr>
        </thead>
      </table>

      <div class="table_body">
        <table class="table_component">
          <tbody>
            <tr
              v-for="(keyword, index) in sortedKeywords"
              :key="index"
            >
              <td
                class="keyword"
                style="width: 35%"
              >
                {{ keyword.keyword.keyword }}
              </td>
              <td
                :title="getRankingTooltip(keyword)"
                class="position tooltipster"
                style="width: 20%"
                v-html="getRankingChange(keyword)"
              />
              <td
                class="volume"
                style="width: 20%"
              >
                {{ (keyword.search_volume > 0 ? keyword.search_volume.toLocaleString() : '< 10') }}
              </td>
              <td
                class="difficulty"
                style="width: 25%"
              >
                <difficulty-tag
                  :difficulty="
                    keyword.difficulty !== 999
                      ? keyword.difficulty
                      : keyword.calculated_difficulty
                  "
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <div v-if="loading">
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>
      <div v-else>
        No keywords found
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import DifficultyTag from "../../../../js/components/global/assets/DifficultyTag";

export default {
  components: {
    DifficultyTag,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keywords: [],
      loading: true
    }
  },
  computed: {
    ...mapState('dashboard', ['uuid', 'preview']),
    sortedKeywords() {
      return _.orderBy(
          this.keywords,
          [
            (kw => {
              return kw.current_position || 1000
            }), // Set to 1000 if null so its at the bottom
            'search_volume'
          ],
          ['asc', 'asc']
      );
    }
  },
  mounted() {
    axios.post('/ajax/dashboard/get-widget-data', {
      type: 'topKeywords',
      uuid: this.uuid
    }).then(response => {
      this.keywords = response.data;
      this.loading = false;
    }).catch(error => {
      console.log(error);
    });
  },
  methods: {
    getRankingChange(keyword) {
      if (!keyword.current_position) return '<i class="fa fa-btn fa-spinner fa-spin"/>'
      if (keyword.previous_month == null) return `${keyword.current_position > 100 ? '100+' : keyword.current_position}`;

      let difference = keyword.current_position - keyword.previous_month;
      if (difference === 0) return `${keyword.current_position > 100 ? '100+' : keyword.current_position} <span style="font-size: smaller;"><i class="fal fa-minus"></i></span>`;
      if (difference < 0) return `${keyword.current_position > 100 ? '100+' : keyword.current_position}  <span style="font-size: smaller; color: #37B2A8;"><i style="margin-right: .25rem" class="fas fa-caret-up"></i>${difference * -1}</span>`;
      if (difference > 0) return `${keyword.current_position > 100 ? '100+' : keyword.current_position}  <span style="font-size: smaller; color: #F34F4F;"><i style="margin-right: .25rem" class="fas fa-caret-down"></i>${difference}</span>`;
    },
    getRankingTooltip(keyword) {
      if (!keyword.previous_month || keyword.previous_month === keyword.current_position) return null;
      return `Your previous position was ${keyword.previous_month > 100 ? '100+' : keyword.previous_month}`
    }
  },
}
</script>

<style scoped>
tr td:not(:first-of-type) {
  text-align: center;
}

.table_body {
  max-height: 266px;
  overflow-y: auto;
}
</style>
